<template>
  <div class="inquery">
    <div class="box">
      <div class="logo" @click="goHome">
        <h1>北京佰标技术服务中心</h1>
      </div>
      <div class="formin">
        <div class="title">
            <ul>
              <li class="title">查询栏目</li>
              <li :class="selectid == item.id&&'select'" v-for="item in column" :key="item.id" @click="handleColumn(item.id)">{{item.name}}</li>
            </ul> 
        </div>
        <div class="info">
          <h2>{{ titleName }}</h2>
          <p>证书信息查询一律免费，查询结果供参考</p>
          <input type="text" v-model="cname" name="cname" :placeholder="cnameplaceholder" class="cname">
          <input type="text" v-model="ccode" name="cname" :placeholder="ccodeplaceholder" class="ccode">
          <input type="text" v-model="bzcode" name="bzcode" :placeholder="bzcodeplaceholder" class="bzcode">
          <input type="button" value="查询" @click="query" class="inq">
        </div>
      </div>
      <div class="copyright">©CopyRight 2002-2020 版权所有</div>
      <div class="code-select" v-show="occupationFlag">
        <el-dialog title="请选择职业名称"  :visible.sync="occupationFlag">
          <el-form :model="form">
            <el-form-item label="职业名称">
              <el-select v-model="form.certname" placeholder="请选择职业名称">
                <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="occupationFlag = false">取 消</el-button>
            <el-button type="primary" @click="handleInq()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 
查询栏目  1、企业证书查询系统 （单位名称+信用代码+证书编号）
2、企业荣誉查询系统 （单位名称+信用代码+证书编号）
3、企业牌匾查询系统 （单位名称+信用代码+证书编号）
3、主编单位查询系统 （单位名称+信用代码+标准号）
4、参编单位查询系统  （单位名称+信用代码+标准号）
（主办单位和参编单位公用一个查询模块即可）
5、主编人员查询系统   （姓名+身份证号+证书编号）
6、参编人员查询系统  （姓名+身份证号+证书编号）
（主办人员和参编人员公用一个查询模块即可）
 */
import { certificateCBDW, certificateQYPB, certificateQYRY, certificateQYZS, certificateCBRY, certificateZBRY, certificateZBDW } from '@/request/index';
const rate = window.outerWidth / 1230;
export default {
  metaInfo: {
    title: '北京佰标技术服务中心',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "inquery",
  components: {
  },
  data() {
    return {
      occupations: [],
      form: {
        certname: "",
      },
      occupationFlag:false,
      cname: "",
      ccode: "",
      bzcode: "",
      cnameplaceholder:"单位名称",
      ccodeplaceholder:"信用代码",
      bzcodeplaceholder:"证书编号",
      titleName: "企业证书查询系统",
      selectid:0,
      column: [{
        id: 0,
        name: "企业证书查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "证书编号",
        func: certificateQYZS
      }, {
        id: 1,
        name: "主编单位查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "标准号",
        func: certificateZBDW
      }, {
        id: 2,
        name: "参编单位查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "标准号",
        func: certificateCBDW
      }, {
        id: 3,
        name: "主编人员查询系统",
        cname: "姓名",
        ccode: "身份证号",
        bzcode: "证书编号",
        func: certificateZBRY
      }, {
        id: 4,
        name: "参编人员查询系统",
        cname: "姓名",
        ccode: "身份证号",
        bzcode: "证书编号",
        func: certificateCBRY
      }, {
        id: 5,
        name: "企业荣誉查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "证书编号",
        func: certificateQYRY
      }, {
        id: 6,
        name: "企业牌匾查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "证书编号",
        func: certificateQYPB
      }]
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    handleColumn(index) {
      let item = this.column[index];
      this.cnameplaceholder = item.cname;
      this.ccodeplaceholder = item.ccode;
      this.bzcodeplaceholder = item.bzcode;
      this.titleName = item.name;
      this.selectid = item.id;
    },
    handleInq() {
      if (!this.form.certname) {
        this.$message.error("请选择职业名称");
        return;
      }
      this.$router.push({
        name: "Show",
        query: {
          cname: this.cname,
          ccode: this.ccode,
          bzcode: this.bzcode,
          selectid: this.selectid,
          certname: this.form.certname
        }
      })
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async query() {
      if (this.cname == "" && this.ccode == ""
        || this.cname == "" && this.bzcode == ""
        || this.ccode == "" && this.bzcode == "") {
        return;
      }
      let result = await this.column[this.selectid].func(this.bzcode, this.cname, this.ccode);
      if (result.success && result.data.length===1) {
        this.form.certname = result.data[0].certname;
        this.handleInq();
        return;
      }
      if (result.success && result.data.length) {
        this.occupations = result.data || [];
        this.occupationFlag = true;
      } else {
        this.$message.error("无法查询到信息，请确认信息是否填写正确！");
      }
    }
  }
};
</script>
<style scoped>
.inquery{
  position: relative;
  width: 100%;
  height: 1080px;
  background: url(/static/img/inq/bg.png) no-repeat;
  background-size: auto;
}
.inquery>.box{
  position: relative;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.box>.logo{
  position: relative;
  margin-top:36px;
  height: 104px;
  background: url(/static/img/inq/logo1.png) no-repeat;
  background-size: 511px 104px;
  overflow: hidden;
}
.box>.logo>h1{
  position: absolute;
  left:-1116px;
}
.box>.formin{
  position: relative;
  margin-top: 117px;
  margin-left: 147px;
  width: 965px;
  height: 659px;
  background: #FFFFFF;
  box-shadow: -1px 4px 18px 0px rgba(0, 170, 185, 0.41);
  border-radius: 12px;
  display: flex;
  justify-content: start;
}
.box>.formin>.title {
  width: 233px;
  height: 659px;
  background: #F4F7FA url(/static/img/inq/icon_ta.png) no-repeat;
  background-size: 233px;
  background-position: bottom center;
  border-radius: 12px 0px 0px 12px;
}
.box>.formin>.info{
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}
.box>.formin>.title>ul{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.box>.formin>.title>ul>li{
  width: 100%;
  height: 63px;
  font-size: 16px;
  line-height: 63px;
  padding-left: 51px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.box>.formin>.title>ul>li.select {
  padding-left: 67px;
  background-color: #FFFFFF;
  background-image: url(/static/img/inq/icon_youjiantou.png);
  background-repeat: no-repeat;
  background-position:15px center;
}
.box>.formin>.title>ul>li.title {
  position: relative;
  padding-left: 69px;
  height: 74px;
  font-size: 24px;
  line-height: 74px;
}
.box>.formin>.title>ul>li.title::before{
  content: '';
  position: absolute;
  top: 29px;
  left: 47px;
  width: 7px;
  height: 16px;
  background: url(/static/img/inq/icon_you.png) no-repeat;
  background-size: 7px 16px;
}
.box>.formin>.title>ul>li.title::after {
  content: '';
  position: absolute;
  top:29px;
  left:176px;
  width: 7px;
  height: 16px;
  background: url(/static/img/inq/icon_zuo.png) no-repeat;
  background-size: 7px 16px;
}
.box>.formin>.info>h2 {
  position: relative;
  margin-top: 69px;
  width: 399px;
  height: 46px;
  font-size: 46px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2372BA;
  line-height: 46px;
}
.box>.formin>.info>p{
  margin-top:17px;
  width: 353px;
  height: 18px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #808080;
  line-height: 18px;
}
.box>.formin>.info>input{
  padding-left: 20px;
  width: 594px;
  height: 68px;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  font-size: 20px;
  line-height: 68px;
  font-family: PingFang SC;
  color: #808080;
}
.box>.formin>.info>input.inq{
  margin-top: 29px;
  width: 614px;
  height: 72px;
  background: #006DC0;
  color: #FFFFFF;
  font-weight: bold;
  padding-left: 0;
  font-size: 24px;
  line-height: 72px;
}
.box>.formin>.info>input.inq:hover{
  cursor: pointer;
}
.box>.formin>.title>ul>li:hover{
  cursor: pointer;
}
.box>.formin>.info>input.cname{
  margin-top: 82px;
}
.box>.formin>.info>input.ccode {
  margin-top: 27px;
}
.box>.formin>.info>input.bzcode {
  margin-top: 26px;
}
.box>.copyright {
  position: relative;
  margin-top: 129px;
  margin-left: 490px;
  width: 219px;
  height: 13px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 13px;
}
</style>
